import $ from 'jquery';

var PageUtils = {
    navbarHeight: function() {
        return  ($('.navbar-fixed-top').height() || 0) + ($('.progress-list').height() || 0);
    }
}

export default PageUtils;
